import script from "./earning-amazon-brand-referral-bonus.vue?vue&type=script&setup=true&lang=js"
export * from "./earning-amazon-brand-referral-bonus.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__